module.exports = __webpack_public_path__ + "c9b71ec44752ba9698d4ba985131eb79.jpg";